import { useState } from "react";
import LoadingAnimation from "@assets/svg/LoadingAnimation";
import { markUnmarkFavoriteMatchedJobs } from "@endpoints/job.service";
import dayjs from "@lib/dayjs";
import { useSnackbar } from "notistack";
import AnimatedCircleProgress from "@components/AnimatedCircleProgress";
import { NavLink } from "react-router-dom";
import { StarIcon } from "lucide-react";
import StarFilledIcon from "@assets/svg/StarFilledIcon";

const JobCard = ({ data, onClick }) => {
    const { enqueueSnackbar } = useSnackbar()
    const [isMarkedFavorite, setIsMarkedFavorite] = useState(data?.isMarkFavorite)
    const [isMarking, setIsMarking] = useState(false)

    const isAspiration = data?.tag === 'Aspiration'

    const handleMarkUnmarkFavorite = async () => {
        try {
            setIsMarking(true)
            await markUnmarkFavoriteMatchedJobs({
                isMarkFavorite: !isMarkedFavorite,
                matchId: data?._id,
                tag: data?.tag
            })
            setIsMarkedFavorite((prev) => !prev)
        } catch (error) {
            enqueueSnackbar(error, { variant: 'error' })
        } finally {
            setIsMarking(false)
        }
    }

    return (
        <NavLink
            to={"/job-matches-details"}
            state={{ item: data }}
            onClick={onClick}
            className="grid grid-cols-[0.9fr_1.6fr_0.5fr] gap-10 items-center py-6 border-b pl-2 hover:bg-gray-50"
        >
            <div className="flex flex-col gap-1.5">
                <span className="text-xs italic text-light-black font-semibold mb-8">Posted By: &nbsp; &nbsp; <span className="text-primary">{data?.recruiterCompanyName}</span></span>
                <div className="flex items-center text-xs text-primary">
                    <span className="w-20 text-light-black">Location:</span>
                    <span>London</span>
                </div>
                <div className="flex items-center text-xs text-primary">
                    <span className="w-20 text-light-black">Job Type:</span>
                    <span>Full Time/Work from home</span>
                </div>
                <div className="flex items-center text-xs text-primary">
                    <span className="w-20 text-light-black">Salary:</span>
                    <span>Competitve</span>
                </div>
            </div>

            <div className="flex flex-col gap-2">
                <span className="text-sm font-bold text-primary mb-2">{data?.jobTitle}</span>
                <div className="flex items-center gap-5 h-[1rem]">
                    {data?.latestTrackerDetails?.createdAt ? (
                        <>
                            <span className="text-xs text-light-black font-medium italic">
                                {dayjs(data?.latestTrackerDetails?.createdAt).format("hh:mm a")}
                            </span>
                            <span className="text-xs text-light-black font-medium italic">
                                {dayjs(data?.latestTrackerDetails?.createdAt).format("DD MMM YYYY")}
                            </span>
                        </>
                    ) : null}
                </div>
                <div className="flex items-center border border-gray-200 bg-gray-50 rounded-md h-[3.8rem] py-3 px-5">
                    <span className="text-xs font-medium text-primary">
                        Latest Activity : {data?.latestTrackerDetails?.status || 'N/A'}
                    </span>
                </div>
            </div>

            <div className="flex h-full gap-8">
                <div className="flex flex-col items-center gap-7">
                    <span className="text-xs font-medium text-primary bg-gray-50 rounded-md py-1.5 w-32 border text-center">
                        {isAspiration ? 'Aspirations' : 'Profile'} Match
                    </span>
                    <div className="relative">
                        <AnimatedCircleProgress
                            progress={data?.matchingPercentage}
                            suffix="%"
                            size={63}
                            textStyle="font-bold"
                        />
                    </div>
                </div>
                <div className="relative h-full w-10">
                    <button
                        onClick={(e) => {
                            e?.preventDefault()
                            e?.stopPropagation()
                            handleMarkUnmarkFavorite()
                        }}
                        className="hover:bg-gray-100 rounded-full p-1.5 absolute -top-5"
                    >
                        {
                            isMarking ?
                                <LoadingAnimation color="#2e2e2e" /> :
                                isMarkedFavorite ?
                                    <StarFilledIcon className={'h-5 w-5'} fill="#2e2e2e" />
                                    :
                                    <StarIcon color="#2e2e2e" size={20} strokeWidth={1} />
                        }
                    </button>
                </div>
            </div>


        </NavLink>
    );
};

export default JobCard
